﻿import BaseDatalayerEvent from './base-datalayer-event.js';
import DataLayerFileDownload from '../classes/datalayer-file-download.js';

export default class FileDownloadEvent extends BaseDatalayerEvent {
    constructor(name, format, type, url) {
        super('file_download');
        this.downloads = new DataLayerFileDownload(name, format, type, url);
    }
}